import { cn } from '../utilities.ts'
import { IconProps, IconType } from './types.ts'

export const TrashCanIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-trash', type, className)}></i>
}

export const ViewIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-eye', type, className)}></i>
}

export const EditIconGeneral = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-pencil', type, className)}></i>
}

export const ProfileCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn(`ki-profile-circle`, type, className)}></i>
}

export const ImagePlaceHolderIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-picture', type, className)}></i>
}

export const CalendarIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-calendar', type, className)} />
}

export const MagnifierIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-magnifier', type, className)}></i>
}

export const FilterIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-filter', type, className)}></i>
}

export const GeneralIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-icon', type, className)}></i>
}

export const KebabMenuIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-dots-vertical', type, className)}></i>
}

export const DotsVertical = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-dots-vertical', type, className)}></i>
}

export const DetailsIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-document', type, className)}></i>
}

export const LocationIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-geolocation', type, className)}></i>
}

export const MenuIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-menu', type, className)}></i>
}

export const UserSquareIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-user-square', type, className)}></i>
}

export const ShopIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-shop', type, className)}></i>
}

export const ExclamationCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-information-1', type, className)}></i>
}

export const UserCheckIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-user-tick', type, className)}></i>
}

export const CloseIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-cross', type, className)}></i>
}

export const SideBarOpenIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-black-right-line', type, className)}></i>
}

export const SideBarCloseIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-black-left-line', type, className)}></i>
}
export const EyeIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-eye', type, className)}></i>
}

export const EyeSlashIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-eye-slash', type, className)}></i>
}

export const CheckCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-check-circle', type, className)}></i>
}

export const MessageNotificationIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-message-notify', type, className)}></i>
}

export const EmailIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-sms', type, className)}></i>
}

export const InfoCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-information-2', type, className)}></i>
}

export const ArrowExitUpIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-exit-up', type, className)}></i>
}

export const TimeIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-time', type, className)}></i>
}

export const PlusIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-plus', type, className)}></i>
}

export const MinusIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-minus', type, className)}></i>
}

export const UpIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-up', type, className)}></i>
}

export const DownIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-down', type, className)}></i>
}

export const FailCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-cross-circle', type, className)}></i>
}
